import { render, staticRenderFns } from "./policyholder-form.vue?vue&type=template&id=6c5da268&scoped=true&"
import script from "./policyholder-form.vue?vue&type=script&lang=js&"
export * from "./policyholder-form.vue?vue&type=script&lang=js&"
import style0 from "./policyholder-form.vue?vue&type=style&index=0&id=6c5da268&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5da268",
  null
  
)

export default component.exports